import Lista from './Lista';

export const AvaliacaoExperienciaLista = Lista;

export default AvaliacaoExperienciaLista;
